import { Injectable, EventEmitter } from '@angular/core'
import { DailySteps } from './path/path-daily-steps-v2.model'
export interface InternalStateType {
  [key: string]: any
}

@Injectable()
export class AppState {

  public _state: InternalStateType = { }
  public showTutorialBtnClick: EventEmitter<null> = new EventEmitter<null>()
  public refreshMainComponent: EventEmitter<null> = new EventEmitter<null>()
  /**
   * Already return a clone of the current state.
   */
  public get state() {
    return this._state = this._clone(this._state)
  }
  /**
   * Never allow mutation
   */
  public set state(value) {
    throw new Error('do not mutate the `.state` directly')
  }

  public get(prop?: any) {
    /**
     * Use our state getter for the clone.
     */
    const state = this.state
    return state.hasOwnProperty(prop) ? state[prop] : null
  }

  public set(prop: string, value: any) {
    /**
     * Internally mutate our state.
     */
    return this._state[prop] = value
  }

  private _clone(object: InternalStateType) {
    /**
     * Simple object clone.
     */
    return Object.assign({}, object)
  }
  
updateAcrossSteps(steps: DailySteps[], key: string, id: any, diff?) {
  for (const step of steps) {
    const collection = step[key];

    if (Array.isArray(collection)) {
      const idx = collection.findIndex(elem => elem.id === id);
      if (idx !== -1) {
        return step.update(key, id, diff); // mutate in place
      }
    }
    else if (collection && collection.id === id) {
      return step.update(key, id, diff); // mutate in place
    }
  }
  return false;
}

/**
 * Persist an in-step v2 screen-content update (e.g. { isCompleted: true }) into BOTH the
 * DailyStepsData copy (drives the current render) AND currentPath.kyperChapters — the source
 * that DailyStepsData is re-derived from when the in-step is closed and re-opened
 * (refetchChapterSteps). A plain reference mutation only touches the DailyStepsData copy and is
 * lost on that re-derive, so completion must be written to both. Screens are matched by
 * screenContentId, or by screenType (marks every screen of that type — used for the multi-screen
 * notification flow, where confirming the reminder time completes settings + confirmation +
 * calendar screens at once).
 */
persistScreenContent(diff: any, opts: { screenContentId?: any; screenType?: string } = {}) {
  if (!diff) { return; }
  const { screenContentId, screenType } = opts;
  const matches = (screen: any) => {
    if (screenContentId != null) { return screen?.screenContents?.id === screenContentId; }
    if (screenType != null) { return screen?.screenType === screenType; }
    return false;
  };
  const apply = (chapters: any[]) => {
    (chapters || []).forEach((chapter: any) =>
      (chapter?.steps || []).forEach((step: any) =>
        (step?.screens || []).forEach((screen: any) => {
          if (matches(screen)) {
            if (!screen.screenContents) { screen.screenContents = {}; }
            Object.assign(screen.screenContents, diff);
          }
        })));
  };
  const dailyStepsData = this.get('DailyStepsData');
  if (dailyStepsData) { apply(dailyStepsData); this.set('DailyStepsData', dailyStepsData); }
  const currentPath = this.get('currentPath');
  if (currentPath?.kyperChapters) { apply(currentPath.kyperChapters); this.set('currentPath', currentPath); }
}


}
